import { createShell } from '../../shell/createShell';
import { route as extrasFastTrackPage } from './pages/fast_track';
import { route as extrasPostBookingSeats } from './pages/Seats/postBookingSeats';
import { route as extrasPostBookingBags } from './pages/Bags/postBookingBags';
import { route as extrasCheckoutPage } from './pages/Checkout/checkout';
import { route as extrasCheckinInfoPage } from './pages/CheckInFunnel/Info';
import { route as extrasCheckinFormPage } from './pages/CheckInFunnel/Form';
import { route as extrasAddPaymentMethodPage } from './pages/Prime/addPaymentMethod';
import { route as extrasAddPaymentMethodConfirmationPage } from './pages/Prime/addPaymentMethodConfirmation';
import { route as extrasPayByLinkMembershipValidationPage } from './pages/Prime/paybylinkMembershipValidator';
import { route as extrasPayByLinkContentValidationPage } from './pages/Prime/paybylinkContentValidator';
import { route as extrasCheckinConfirmationSuccessPage } from './pages/CheckInFunnel/ConfirmationSuccess';
import { route as extrasCheckinUpSellFastTrackPage } from './pages/CheckInFunnel/UpsellFastTrack';
import { ExtrasFunnel } from '.';
const routes = [extrasFastTrackPage, extrasPostBookingSeats, extrasPostBookingBags, extrasCheckoutPage, extrasCheckinInfoPage, extrasCheckinFormPage, extrasCheckinUpSellFastTrackPage, extrasCheckinConfirmationSuccessPage, extrasAddPaymentMethodPage, extrasAddPaymentMethodConfirmationPage, extrasPayByLinkMembershipValidationPage, extrasPayByLinkContentValidationPage];
export const extrasPostbookingShell = createShell(ExtrasFunnel, {
  options: {
    routes,
    namespace: 'extras_postbooking_shell'
  }
});